import React, { useEffect, useState } from 'react'
import listingStyles from "../listing.scss"
import styles from "./index.scss";
import BellIconSvg from './icons/bellIconSvg';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import { setGalleryImageUpload, setNotificationData, setSlider } from './redux/action';
import { useDispatch, useSelector } from 'react-redux';
import { clickTrack } from '../../../actions/products';

const Notifications = () => {

    const [notiCount, setNotiCount] = useState(0)
    const dispatch = useDispatch()
    const getNotificationData = useSelector(state => state?.notifications?.counts)
    const isImageUpload = useSelector(state => state?.notifications?.isImageUpload)
    const token = useSelector(state => state?.session?.token)
    const listing = useSelector(state => state?.products?.listing)
    const user = useSelector(state => state?.session?.user?.loggedUser?.userType)
    const finalCount = (notiCount > 9) ? '9+' : notiCount

    useEffect(() => {
        dispatch(setNotificationData({ token: token }))
        if (isImageUpload) {
            dispatch(setGalleryImageUpload(false))
        }
    }, [listing?.results, isImageUpload])

    useEffect(() => {
        const { rejectedCount = 0, imgMissingCount = 0, priceMissingCount = 0, specMissingCount = 0, descMissingCount = 0, scoreLessThanHundred = 0 } = getNotificationData
        const tmpNotiCount = rejectedCount + (user == 'OWNER' ? imgMissingCount : 0) + priceMissingCount + specMissingCount + descMissingCount + (user && user != "OWNER" ? scoreLessThanHundred : 0)
        setNotiCount(tmpNotiCount)
    }, [getNotificationData])

    return (
        <AnimateOnHover
            className={listingStyles['full-height']}
            role="button"
            aria-label={notiCount > 0 ? `Notifications, ${notiCount} unread` : 'Notifications'}
            tabIndex={0}
            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') e.currentTarget.click(); }}
            onClick={() => {
                setTimeout(() => {
                    dispatch(setSlider(true));
                    dispatch(clickTrack({
                        li: 'notification_bell',
                        ll: 'digital_catalog',
                        userBasedCheck: true
                    }))
                }, 300);
            }}>
            <div className={`${listingStyles['icon-holder']} ${notiCount > 0 ? styles['bellAnimation'] : ""}`}>
                <BellIconSvg />
            </div>
            {notiCount > 0 ? <div className="notificationCount"><div className='notiCount-fig'>{finalCount}</div></div> : null}

        </AnimateOnHover>
    )
}

export default Notifications